"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountAddress = exports.getWallet = void 0;
const tslib_1 = require("tslib");
const helpers_1 = require("../../helpers");
const getWallet = (options) => {
    const { account, signer } = options || {};
    return {
        account: account ? (0, helpers_1.pCAIP10ToWallet)(account) : account,
        signer,
    };
};
exports.getWallet = getWallet;
const getAccountAddress = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { account, signer } = options || {};
    const pushSigner = new helpers_1.Signer(signer);
    return account || (yield pushSigner.getAddress()) || '';
});
exports.getAccountAddress = getAccountAddress;
//# sourceMappingURL=wallet.js.map